// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Navigation Shared Styles */

.global-navigation-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #ffffff;
  border-bottom: 1px solid rgba(0, 37, 74, 0.07);
}

.product-navigation {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  height: 40px;
  padding: 12px 108px;
  background-color: #ffffff;
  border-bottom: 1px solid rgba(0, 37, 74, 0.07);
}

@media (max-width: 799px) {
  .product-navigation {
    display: none;
  }
}

@media (min-width: 800px) and (max-width: 1023px) {
  .product-navigation {
    padding: 12px 40px;
    gap: 16px;
  }
}

.product-logo {
  position: relative;
  height: 16px;
  flex-shrink: 0;
}

.global-nav-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 108px;
  background-color: #ffffff;
  border-bottom: 1px solid rgba(0, 37, 74, 0.07);
}

@media (max-width: 799px) {
  .global-nav-bar {
    padding: 16px 24px;
  }
}

@media (min-width: 800px) and (max-width: 1023px) {
  .global-nav-bar {
    padding: 16px 40px;
  }
}

.intuit-logo {
  width: 90px;
  height: 18px;
  display: block;
}

`, "",{"version":3,"sources":["webpack://./../shared/styles/GlobalNavigation.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,SAAS;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB","sourcesContent":["/* Global Navigation Shared Styles */\n\n.global-navigation-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  background-color: #ffffff;\n  border-bottom: 1px solid rgba(0, 37, 74, 0.07);\n}\n\n.product-navigation {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n  height: 40px;\n  padding: 12px 108px;\n  background-color: #ffffff;\n  border-bottom: 1px solid rgba(0, 37, 74, 0.07);\n}\n\n@media (max-width: 799px) {\n  .product-navigation {\n    display: none;\n  }\n}\n\n@media (min-width: 800px) and (max-width: 1023px) {\n  .product-navigation {\n    padding: 12px 40px;\n    gap: 16px;\n  }\n}\n\n.product-logo {\n  position: relative;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.global-nav-bar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 108px;\n  background-color: #ffffff;\n  border-bottom: 1px solid rgba(0, 37, 74, 0.07);\n}\n\n@media (max-width: 799px) {\n  .global-nav-bar {\n    padding: 16px 24px;\n  }\n}\n\n@media (min-width: 800px) and (max-width: 1023px) {\n  .global-nav-bar {\n    padding: 16px 40px;\n  }\n}\n\n.intuit-logo {\n  width: 90px;\n  height: 18px;\n  display: block;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
